module.exports = __webpack_public_path__ + "c_static/img/10查看问答.66f3edb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/10查看问答.jpg
// module id = figy
// module chunks = 33